export const selectPermissionsLoading = (state) => state.accountPermissions.loading;
export const selectPermissionsList = (state) => state.accountPermissions.list;
